import { action, observable } from 'mobx';

import { ANCHOR_VIEW_PURCHASED_CLIPSTORE_GALLERY, ANCHOR_VIEW_PURCHASED_CLIPSTORE_VIDEO } from '../constants/apiUrls/apiUrls';
import callApi from '../utils/callApi';


class PayPerViewStore {
  @observable isFirstWSEvent = true;

  @action setIsFirstWSEvent = (value) => {
    this.isFirstWSEvent = value;
  };

  @observable intervalID = null;

  @action setIntervalID = (value) => {
    this.intervalID = value;
  };

  @observable payPerViewNav = 'New';

  @action setPayPerViewNav = (value) => {
    this.payPerViewNav = value;
  };

  @observable paymentLoading = false;

  @action setPaymentLoading = (value) => {
    this.paymentLoading = value;
  };

  @observable purchasedClip = { id: '', type: '' };

  @action setPurchasedClip = (value) => {
    this.purchasedClip = value;
  };

  @observable showPayPerViewModal = false;

  @action setShowPayPerViewModal = (value) => {
    this.showPayPerViewModal = value;
  };

  @observable statusMessage = '';

  @action setStatusMessage = (value) => {
    this.statusMessage = value;
  };

  @observable newItemWasPurchased = false;

  @action setNewItemWasPurchased = (value) => {
    this.newItemWasPurchased = value;
  };

  @observable timerStarted = false;

  @action setTimerStarted = (value) => {
    this.timerStarted = value;
  };

  @observable currentlySelectedAnchor = '';

  @action setCurrentlySelectedAnchor = (value) => {
    this.currentlySelectedAnchor = value;
  };

  @observable currentlySelectedAnchorID = '';

  @action setCurrentlySelectedAnchorID = (value) => {
    this.currentlySelectedAnchorID = value;
  };

  @observable shouldRefreshItemsList = false;

  @action setShouldRefreshItemsList = (value) => {
    this.shouldRefreshItemsList = value;
  };

  decideContentUrl = (itemId, itemType, temptationId) => {
    if (itemType === 'VIDEO') {
      return ANCHOR_VIEW_PURCHASED_CLIPSTORE_VIDEO.
        replace('{id}', encodeURIComponent(temptationId)).
        replace('{videoId}', encodeURIComponent(itemId));
    }

    return ANCHOR_VIEW_PURCHASED_CLIPSTORE_GALLERY.
      replace('{id}', encodeURIComponent(temptationId)).
      replace('{galleryId}', encodeURIComponent(itemId));
  };

  @action purchaseNotifyEventHandler(event) {
    const { itemId, itemType, temptationId } = event.content;
    if (this.isFirstWSEvent && parseInt(this.purchasedClip.id, 10) !== parseInt(itemId, 10)) {
      this.setIsFirstWSEvent(false);

      return;
    }
    const url = this.decideContentUrl(itemId, itemType, temptationId);
    callApi(url, 'GET', undefined, undefined, undefined, true, true, true).
      then((res) => {
        clearTimeout(this.intervalID);
        this.setIntervalID(null);
        this.setTimerStarted(false);
        this.setPaymentLoading(false);
        this.setPayPerViewNav('Purchased');
        this.setNewItemWasPurchased(true);
        if (window.FeaturedSection) {
          window.FeaturedSection.openPurchased();
        }
      }).
      catch((err) => {
        console.error(`There was an error: ${err}`);
      });
  }
}

export default new PayPerViewStore();
